import getStore from '../store/store';

/**
 * Selector to get personal booking button flight enabled status from store.
 */
export default function getOWACalendarBookingButtonEnabled(): boolean {
    return getStore().owaCalendarBookingButtonEnabled;
}
